<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconFilterClear"
})
</script>

<template>
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M362.667 256a106.667 106.667 0 0 1 106.666 106.667c0 58.91-47.756 106.666-106.666 106.666S256 421.577 256 362.667 303.756 256 362.667 256Zm0 21.333c-47.129 0-85.334 38.205-85.334 85.334 0 47.128 38.205 85.333 85.334 85.333C409.795 448 448 409.795 448 362.667c0-47.129-38.205-85.334-85.333-85.334Zm36.543 33.706 15.085 15.085-36.544 36.543 36.544 36.543-15.085 15.085-36.543-36.544-36.543 36.544-15.085-15.085 36.543-36.543-36.543-36.543 15.085-15.085 36.543 36.543 36.543-36.543ZM384 85.333l-149.333 182v122H192v-122l-149.333-182H384Z" fill-rule="evenodd"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
